const urlUtility = {
  /**
   *
   * @param {String} url
   * @returns {Promise}
   */
  getMeta(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = url;
    });
  },
  /**
   *
   * @param {String} url
   * @returns {String}
   */
  getYouTubeVideoId(url) {
    const regex
      = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
    return regex.exec(url)[3];
  },
};

export default urlUtility;
